import { LocalStorageKey } from "../localStoragePersistence/common/LocalStorageKey";

export const DeviceLocalStorageKeys = {
  readableName: new LocalStorageKey("Device", "readableName"),
  identifier: new LocalStorageKey("Device", "identifier"),
  color: new LocalStorageKey("Device", "color"),
} as const;
